const navigation = {
  main: [
    { name: "About", href: "#" },
    { name: "Blog", href: "#" },
    { name: "Jobs", href: "#" },
    { name: "Press", href: "#" },
    { name: "Accessibility", href: "#" },
    { name: "Partners", href: "#" },
  ],
  social: [
    {
      name: "X",
      href: "https://twitter.com/InjeraOfficial",
      icon: "/images/twitter.svg",
    },
    {
      name: "Telegram",
      href: "https://t.me/InjeraOfficial",
      icon: "/images/telegram.svg",
    },
    {
      name: "Docs",
      href: "https://docs.injera.io",
      icon: "/images/gitbook.svg",
    },
  ],
};

export default function Footer() {
  return (
    <footer>
      <div className="mx-auto max-w-7xl overflow-hidden px-6 py-6 lg:px-8">
        {/* <nav
          className="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12"
          aria-label="Footer">
          {navigation.main.map((item) => (
            <div key={item.name} className="pb-6">
              <a
                href={item.href}
                className="leading-6 text-white hover:opacity-80">
                {item.name}
              </a>
            </div>
          ))}
        </nav> */}
        <div className="flex justify-center space-x-10">
          {navigation.social.map((item) => (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              className="text-white hover:opacity-80">
              <span className="sr-only">{item.name}</span>
              <img
                src={item.icon}
                alt={item.name}
                className="h-6 w-6"
                aria-hidden="true"
              />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
